export enum ViewBreakpoint {
  Small,
  Medium,
  Large
}
